export * from './contact';
export * from './staticPage';
export * from './staticPages';
